// Helper functions
function replaceUrlParam(url, paramName, paramValue) {
  var pattern = new RegExp('('+paramName+'=).*?(&|$)'),
      newUrl = url.replace(pattern,'$1' + paramValue + '$2');
  if ( newUrl == url ) {
    newUrl = newUrl + (newUrl.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
  }
  return newUrl;
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $('body'),

    // Navigation
    $navigation: $('#AccessibleNav'),

    // Product Page
    $productImageWrap: $('#ProductPhoto'),
    $productImage: $('#ProductPhotoImg'),
    $thumbImages: $('#ProductThumbs').find('a.product-single__thumbnail')
  }
};

timber.init = function () {
 //  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.productImageSwitch();
  timber.autoResponsiveElements();
  timber.productImageZoom();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector,
      translations = options.translations;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('.ProductPrice'),
      $comparePrice = $('.ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $outofstock = $('.outofstock'),
      $addToCartText = $('#AddToCartText'),
      $notifyMeBtn = $('.klaviyo-bis-trigger');

  if (variant) {  

    // BLOOMR: update product owl slider
    if (variant.featured_image) {
      // get image ID
      var imgId = variant.featured_image.id;
      // click on slider thumb with same id
      $('.product-thumbs-item a[data-image-id="'+imgId+'"]').click();
    }

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html(translations.add_to_cart);
      $quantityElements.show();
      $outofstock.hide();
      $notifyMeBtn.removeClass('show');
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html(translations.sold_out);
      $quantityElements.hide();
      $outofstock.show();
      $notifyMeBtn.addClass('show');
    }

    // Regardless of stock, update the product price
    
     	var cookieCurrency = Currency.cookie.read();
		if(typeof Currency !== 'undefined' && $productPrice.length && shopCurrency && cookieCurrency){
			var convertedPrice = Currency.convert(variant.price,shopCurrency,cookieCurrency);
			$productPrice.html(Shopify.formatMoney(convertedPrice, Currency.moneyFormats[cookieCurrency].money_with_currency_format));
		}
	
    $productPrice.removeAttr("data-currency-aed");
    $productPrice.removeAttr("data-currency-sar");
    $productPrice.removeAttr("data-currency-omr");
    $productPrice.removeAttr("data-currency-kwd");
    $productPrice.removeAttr("data-currency-bhd");
   
    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      
       
      var cookieCurrency = Currency.cookie.read();
      if(typeof Currency !== 'undefined' && $comparePrice.length && shopCurrency && cookieCurrency){
        var convertedPrice = Currency.convert(variant.compare_at_price,shopCurrency,cookieCurrency);
        $comparePrice.find("span").html(Shopify.formatMoney(convertedPrice, Currency.moneyFormats[cookieCurrency].money_with_currency_format));
        $comparePrice.show();
        $comparePrice.next('.save_tag').show();
      }
      
      
      $comparePrice.find("span").removeAttr("data-currency-aed");
      $comparePrice.find("span").removeAttr("data-currency-sar");
      $comparePrice.find("span").removeAttr("data-currency-omr");
      $comparePrice.find("span").removeAttr("data-currency-kwd");
      $comparePrice.find("span").removeAttr("data-currency-bhd");
   
      
    } else {
      $comparePrice.hide();
      $comparePrice.next('.save_tag').hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html(translations.unavailable);
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      var newImageId = $(this).attr('data-image-id');
      timber.switchImage(newImage, { id: newImageId }, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
  $el.attr('data-image-id', imgObject.id);

  
};

timber.autoResponsiveElements = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $('table').wrap('<div class="table-wrapper"></div>');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.productImageZoom = function () {
  
    return;
  

  if (!timber.cache.$productImageWrap.length || timber.cache.$html.hasClass('supports-touch')) {
    return;
  };

  // Destroy zoom (in case it was already set), then set it up again
  timber.cache.$productImageWrap.trigger('zoom.destroy');

  timber.cache.$productImageWrap.addClass('image-zoom').zoom({
    url: timber.cache.$productImage.attr('data-zoom')
  });
};

// Initialize Timber's JS on docready
$(timber.init)


$(window).load(function () {
  if($('.product_tag_collection_section').length > 0) {
    var parent_height = $('.product_tags_wrapper_block').outerHeight();
    $('.collection_grid').css('max-height',parent_height);
    $('.other_product_tags_wrapper_block').removeClass('hide');
    $(window).resize(function () {
      var parent_height = $('.product_tags_wrapper_block').outerHeight();
      $('.collection_grid').css('max-height',parent_height);
    });
  }
});
$(document).ready(function () {
  $('.grid-link-other-choises').each( function() {   
    if($(this).find('.product-thumbs-item').length >=3 ) {
      $(this).owlCarousel({
        nav:true,
        items: 3,
        loop: true,
        autoplay: false,
        autoplayTimeout: 4000,
        autoplaySpeed: 750,
        navText: ['<img src="//www.bloomr.com/cdn/shop/t/99/assets/product-slider-arrow-left.png?v=28406240592392335921651590555"/>','<img src="//www.bloomr.com/cdn/shop/t/99/assets/product-slider-arrow-right.png?v=87071194193309311061651590556"/>']
                  });
                  }
                  });

                
                  });